import React, { useState } from "react";
import AddActionDialog from "./AddActionDialog.js";

import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

import AddButton from "components/CustomButtons/AddButton";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function UploadActionPlans(props) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <AddButton handleSubmit={handleClickOpen}>
        <AddIcon
          fontSize="small"
          style={{
            marginRight: "6px",
          }}
        />
        Nouvelle action
      </AddButton>
      <Dialog
        onClose={handleClose}
        aria-labelledby="addScenario-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={open}
      >
        <DialogTitle id="addScenario-dialog-title" onClose={handleClose}>
          Créer une action
        </DialogTitle>
        <DialogContent dividers>
          <AddActionDialog closeModal={handleClose} {...props} />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </>
  );
}
